import { NgModule } from '@angular/core';
import { SelectSearchComponent } from '../../components/select-search/select-search.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule
  ],
  declarations: [
    SelectSearchComponent
  ],
  exports: [
    MatButtonModule,
    MatInputModule,
    SelectSearchComponent
  ]
})
export class SelectSearchModule { }
